import { Component, forwardRef, Input, Optional } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl, ControlContainer } from '@angular/forms';
import {
  Alignment,
  BlockQuote,
  Bold,
  ClassicEditor,
  Code,
  FindAndReplace,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  Heading,
  Highlight,
  Image,
  ImageToolbar,
  ImageCaption,
  ImageStyle,
  ImageResize,
  Italic,
  Link,
  List,
  Paragraph,
  RemoveFormat,
  SelectAll,
  Strikethrough,
  TodoList,
  Underline,
  Undo,
  ImageUpload
} from 'ckeditor5';

@Component({
  selector: 'app-input-ckeditor',
  templateUrl: './input-ckeditor.component.html',
  styleUrls: ['./input-ckeditor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputCkeditorComponent),
      multi: true
    }
  ]
})
export class InputCkeditorComponent implements ControlValueAccessor {

  public Editor = ClassicEditor;
  public editorData: string = '';
  @Input() label = 'Descripción';
  @Input() formControlName!: string;
  public editorConfig: any = {
    toolbar: [
      'cut', 'copy', 'paste', 'pasteText', 'pasteFromWord', '-', 'undo', 'redo', '|',
      'sourceEditing', '|',
      'heading', '|',
      'bold', 'italic', 'strikethrough', 'underline', 'code', '|',
      'bulletedList', 'numberedList', 'todoList', '|',
      'link', 'imageUpload', 'insertTable', 'blockQuote', 'codeBlock',
      'horizontalLine', 'specialCharacters', 'mediaEmbed', '|',
      'alignment', 'fontBackgroundColor', 'fontColor', 'fontFamily', 'fontSize', '|',
      'highlight', 'removeFormat', 'subscript', 'superscript', '|',
      'indent', 'outdent', '|',
      'pageBreak', 'findAndReplace', 'selectAll'
    ],
    plugins: [
      Bold,
      Italic,
      Strikethrough,
      Underline,
      Code,
      Heading,
      List,
      TodoList,
      Link,
      BlockQuote,
      Alignment,
      FontBackgroundColor,
      FontColor,
      FontFamily,
      FontSize,
      Highlight,
      RemoveFormat,
      FindAndReplace,
      SelectAll,
      Undo,
      Paragraph,
      Image,
      ImageToolbar,
      ImageCaption,
      ImageStyle,
      ImageResize,
      ImageUpload,
    ],
    licenseKey: '',
  };

  private onChange: (value: string) => void = () => { };
  private onTouched: () => void = () => { };


  constructor(
    @Optional() private controlContainer: ControlContainer
  ) {

  }


  writeValue(value: string): void {
    this.editorData = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Implementar si es necesario
  }

  onEditorChange({ editor }: any): void {
    const data = editor.getData();
    this.editorData = data;
    if (this.onChange) {
      this.onChange(data);
    }
  }

  onEditorBlur(): void {
    if (this.onTouched) {
      this.onTouched();
    }
  }

  esRequerido(): boolean {
    const control = this.controlContainer?.control?.get(this.formControlName);
    if (control && control.validator) {
      const validator = control.validator({} as any);
      return validator && validator['required'];
    }
    return false;
  }
}